import { render } from "./student_verifyDataTable.vue?vue&type=template&id=94fef392"
import script from "./student_verifyDataTable.vue?vue&type=script&lang=js"
export * from "./student_verifyDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__